<div #title (click)="adminSelection()" class="p-mb-4">
    <h1 *ngIf="sectionContent!==''" class="title-content" [innerHTML]="sectionContent | trustHtml"></h1>
</div>
<p-overlayPanel [dismissable]="true" [showCloseIcon]="true" [focusOnShow]="true" #op [style]="{width: '92%', marginTop: '15px'}">
  <ng-template pTemplate>
    <div *ngIf="defaultLabel && defaultLabel !== ''" class="propertyInput p-formgroup-inline">
      <div class="p-field">
        <label for="DefaultLabelContent" i18n>Default Label</label>
        <input #DefaultLabelContent name="DefaultLabelContent" id="DefaultLabelContent" type="text" pInputText [escape]="false" [disabled]="true" [value]="defaultLabel">
      </div>
    </div>
    <div class="propertyInput p-formgroup-inline">
      <div class="p-field p-mb-3" [style]="{width: '100%'}">
        <label for="FieldLabelContent" i18n>Title Content</label><br />
        <input type="text" pInputText  #FieldLabelContent name="FieldLabelContent" id="FieldLabelContent" [escape]="false" [(ngModel)]="this.sectionContent" />
      </div>
    </div>
    <accela-button-primary type="button" (click)="submitAdminContentUpdate()" i18n-label label="Submit" pRipple></accela-button-primary>
  </ng-template>
</p-overlayPanel>
